import request from '@/utils/request'

export function getLeadPage(params) {
  return request({
    url: '/api/lead/page',
    method: 'get',
    params
  })
}

export function createLead(data) {
  return request({
    url: '/api/lead',
    method: 'post',
    data
  })
}

export function updateLead(id, data) {
  return request({
    url: `/api/lead/${id}`,
    method: 'put',
    data
  })
}

export function assignLead(id, assignedSalesUserId) {
  return request({
    url: `/api/lead/${id}/assign`,
    method: 'put',
    data: { assignedSalesUserId }
  })
}

export function markLeadLost(id) {
  return request({
    url: `/api/lead/${id}/lost`,
    method: 'put'
  })
}

export function deleteLead(id) {
  return request({
    url: `/api/lead/${id}`,
    method: 'delete'
  })
}

export function getLeadDetail(id) {
  return request({
    url: `/api/lead/${id}`,
    method: 'get'
  })
}

export function addFollowup(leadId, data) {
  return request({
    url: `/api/lead/${leadId}/followup`,
    method: 'post',
    data
  })
}

export function addInternalNote(leadId, data) {
  return request({
    url: `/api/lead/${leadId}/internal-note`,
    method: 'post',
    data
  })
}

